import React, { useState } from "react";
import { motion } from "framer-motion";
import Navbar from "../components/navbar";
import { HiUser, HiLockClosed } from "react-icons/hi";
import { FaArrowRight } from "react-icons/fa";
import { post } from "../utils/request";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState("");

  const handleLoginClick = async () => {
    setLoading(true);
    try {
      const response = await post("/../auth/login", formData);
      if (response.success) {
        setShowError("");
        localStorage.setItem("token", response.token);
        localStorage.setItem("username", response.username);
        navigate("/devices");
      } else {
        setShowError(response.error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg">
      <Navbar />

      <div className="min-h-screen flex items-center justify-center px-6 py-10">
        <motion.div
          className="relative z-10 w-full max-w-md"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="bg-gray-800 rounded-3xl shadow-2xl overflow-hidden border border-gray-700">
            <div className="bg-gradient-to-br from-fg to-blue-600 px-8 py-12 text-center">
              <motion.div
                initial={{ scale: 0.8 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <h2 className="text-4xl font-black text-white mb-2">
                  Welcome Back
                </h2>
                <p className="text-blue-100 text-lg">
                  Sign in to access your dashboard
                </p>
              </motion.div>
            </div>

            <div className="p-8">
              <div className="mb-6 p-4 bg-gray-900 border border-gray-700 rounded-xl">
                <p className="text-sm text-gray-400 text-center">
                  <span className="text-fg font-semibold">Demo Access:</span> Use <span className="font-mono text-white">demo:demo</span> to explore the platform with sample data
                </p>
              </div>

              <form
                className="space-y-6"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleLoginClick();
                }}
              >
                <div>
                  <label className="block text-sm font-semibold text-gray-300 mb-2">
                    Username
                  </label>
                  <div className="relative">
                    <HiUser className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" size={20} />
                    <input
                      type="text"
                      className="w-full pl-12 pr-4 py-3 bg-gray-900 border-2 border-gray-700 rounded-xl focus:outline-none focus:border-fg transition-colors text-white placeholder-gray-500"
                      placeholder="Enter your username"
                      value={formData.username}
                      onChange={(e) =>
                        setFormData({ ...formData, username: e.target.value })
                      }
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-300 mb-2">
                    Password
                  </label>
                  <div className="relative">
                    <HiLockClosed className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" size={20} />
                    <input
                      type="password"
                      className="w-full pl-12 pr-4 py-3 bg-gray-900 border-2 border-gray-700 rounded-xl focus:outline-none focus:border-fg transition-colors text-white placeholder-gray-500"
                      placeholder="Enter your password"
                      value={formData.password}
                      onChange={(e) =>
                        setFormData({ ...formData, password: e.target.value })
                      }
                    />
                  </div>
                </div>

                {showError && (
                  <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="bg-red-900/30 border border-red-700 text-red-400 px-4 py-3 rounded-xl text-sm font-medium"
                  >
                    {showError}
                  </motion.div>
                )}

                <button
                  disabled={loading}
                  className={`w-full font-semibold py-4 px-6 rounded-xl transition-all duration-300 flex items-center justify-center gap-2 ${loading
                    ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                    : "bg-fg hover:bg-blue-600 text-white shadow-lg hover:shadow-xl"
                    }`}
                >
                  {loading ? (
                    <>
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      Signing In...
                    </>
                  ) : (
                    <>
                      Sign In
                      <FaArrowRight size={18} />
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>

          <p className="text-center text-gray-500 mt-6">
            Secure access to your monitoring dashboard
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default Login;
